module.exports = __webpack_public_path__ + "img/icon-like-white.33a7e078.svg";